<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/marketing-agency-project-management-software.mjs";
</script>
